<template>
	<client-only>
		<BaseModal v-model="showSzmdModal" :show-close-button="true" title="">
			<div class="flex justify-center items-center align-center px-5">
				<div>
					<h1 class="text-2xl mb-5 font-bold">
						{{ $t(`${modalKey}.${alreadyVoted ? "voted" : "notVoted"}.title`) }}
					</h1>
					<p v-html="$t(`${modalKey}.${alreadyVoted ? 'voted' : 'notVoted'}.copy`)"></p>
					<BaseLink class="w-[280px] mt-8 mb-3" @click="openSzmdBoxVoteModal()">
						<BaseButton type="primary-red" class="w-full">
							{{ $t("vote") }}
						</BaseButton>
					</BaseLink>
				</div>
				<img
					class="w-[250px] hidden sm:block"
					:src="
						alreadyVoted
							? 'https://res.cloudinary.com/djbs/image/upload/v1695735197/content/DreamJobs/Graphics/pic_szmd-letsvote.png'
							: 'https://res.cloudinary.com/djbs/image/upload/v1758186212/content/DreamJobs/Graphics/%C3%9Aj_szavaz%C3%B3_user.svg'
					"
				/>
			</div>
		</BaseModal>
	</client-only>
</template>

<script lang="ts">
import { defineComponent, inject, WatchStopHandle } from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
	name: "ModalSzmdVote",
	props: {
		modelValue: {
			type: Boolean,
			default: false,
		},
	},
	setup(props, { emit }) {
		const { locale } = useI18n();

		const isAuth = useState("isAuth");

		const showSzmdModal = ref(false);

		const region = ref("HU");

		const alreadyVoted = ref(false);

		const { isSzmdVotingPage, szmdVotingInProgress, szmdVotingModalHide, szmdPrizes } = useSzmdConfig();
		const modalKey = szmdPrizes ? "szmdModal" : "szmdNoPrizes.modal";

		onMounted(() => {
			region.value = useRegion.getCurrentRegion().code;

			const COOKIE_MAX_AGE_DAY = 86400; // 1 day (24 * 60 * 60 seconds)
			const COOKIE_MAX_AGE_WEEK = 604800; // 1 week (7 * 24 * 60 * 60 seconds)

			if (!szmdVotingInProgress || isSzmdVotingPage || szmdVotingModalHide) {
				return; // Don't show modal if voting is in not progress and on voting page
			}

			const modalShown = Boolean(useCookie("szmdModalShown").value);

			// Watch for authentication state change
			let stopAuthWatcher: WatchStopHandle;

			// Watch for authentication state change
			stopAuthWatcher = watch(
				isAuth,
				async (newValue) => {
					// if authenticated
					if (newValue) {
						if (stopAuthWatcher) stopAuthWatcher(); // Stop watching after first auth
						// If modal already shown, dont show again.
						if (modalShown) {
							return;
						}

						let user = useAuth.getUser();
						// If user has already voted, set alreadyVoted to true
						alreadyVoted.value = user.has_szmd_votes ?? false;
						showSzmdModal.value = true;

						// If already voted -> weekly cookie, if not yet -> daily cookie
						const maxAge = alreadyVoted.value ? COOKIE_MAX_AGE_WEEK : COOKIE_MAX_AGE_DAY;
						useCookie("szmdModalShown", { maxAge: maxAge }).value = "true";
					}
					// Non-authenticated user -> do nothing, wait for login
				},
				{ immediate: true }
			);
		});

		const openSzmdBoxVoteModal = inject("openSzmdBoxVoteModal");

		return {
			region,
			showSzmdModal,
			alreadyVoted,
			modalKey,
			openSzmdBoxVoteModal,
		};
	},
});
</script>
